import { render, staticRenderFns } from "./ApwCard.vue?vue&type=template&id=41445921&scoped=true&"
import script from "./ApwCard.vue?vue&type=script&lang=js&"
export * from "./ApwCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41445921",
  null
  
)

export default component.exports